module.exports = __webpack_public_path__ + "static/media/bitmap-03@3x.eae4e297.jpg";